import { TRADS } from "./endpoint";
import { get } from "./service-methods";

export const getTrads = (id) => {
  return get(TRADS + `${id}/`);
};
